import React from "react";
import "../../Css/Umang.css";
import { Link, useParams } from "react-router-dom";

const KeyStepService = () => {
    const { category } = useParams();
    const heading = {
        web: "OUR WEB DEVELOPMENT PROCESS",
        mobile: "Key Steps to Mobile App Development Process",
        seo: "SEARCH ENGINE OPTIOMIZATION PROCESS",
        fullStack: "OUR WEB DEVLOPMENT PROCESS",
        digitalMarketing: "DIGITAL MARKETING PROCESS",
        reactNative: "TOP REACT NATIVE FRATURES"
    };
    const webProcess = {
        web: {
            title: ["DISCOVERY", "INFORMATION ARCHITECTURE", "WEBSITE & UI DESIGN", "WEBSITE DEVELOPMENT", "TESTING & DEPLOYMENT", "LAUNCH & LIVE"],
        },
        mobile: {
            title: ["Strategy", "Analusis and Planning", "UI/UX Design", "App Development", "Testing", "Deployment & Support"],
        },
        seo: {
            title: ["WEBSITE ANALYSIS", "PROBLEM IDENTIFICATION", "RESEARCH TARGETED KEYWORDS", "ONE-PAGE SEO", "COMTENT OPTIOMIZATION", "SUBMIT SITE TO SEARCH ENGINE", "OFF PAGES PROMOTION & SEO REPORTING", "RANKING, TRACKING, TRAFIC, REPORTING"],
        },
        fullStack: {
            title: ["DISCOVERY", "INFORMATION ARCHITECTURE", "WEBSITE & UI DESIGN", "WEBSITE DEVELOPMENT", "TESTING & DEPLOYMENT", "LAUNCH & LIVE"],
        },
        digitalMarketing: {
            title: ["PROBLEM", "STRATEGIZE", "BUILD", "OPTIMIZE", "PUBLISH", "PROMOTE", "TRACK", "REFINE"]
        },
        reactNative: {
            title: ["Reusable Components", "UI Focused", "mobile environment performance", "npm for installation", "strong community", "support for 3rd party libraries"]
        }
    };
    const ctaData = {
        web: {
            subtitle: "Get a Free Mobile App Development consultation",
            title: "with our experts today!",
            buttonText: "Contact Us",
            buttonLink: "#contact",
        },
        mobile: {
            subtitle: "Get a Free Mobile App Development consultation",
            title: "with our experts today!",
            buttonText: "Contact Us",
            buttonLink: "#contact",
        },
        seo: {
            subtitle: "Get a Free Mobile App Development consultation",
            title: "with our experts today!",
            buttonText: "Contact Us",
            buttonLink: "#contact",
        },
        responsiveDesign: {
            subtitle: "Get a Free Mobile App Development consultation",
            title: "with our experts today!",
            buttonText: "Contact Us",
            buttonLink: "#contact",
        },
        fullStack: {
            subtitle: "Get a Free Mobile App Development consultation",
            title: "with our experts today!",
            buttonText: "Contact Us",
            buttonLink: "#contact",
        },
        digitalMarketing: {
            subtitle: "Get a Free Mobile App Development consultation",
            title: "with our experts today!",
            buttonText: "Contact Us",
            buttonLink: "#contact",
        },
        reactNative: {
            subtitle: "Get a Free Mobile App Development consultation",
            title: "with our experts today!",
            buttonText: "Contact Us",
            buttonLink: "service/contact",
        }
    };
    const color = [
        "#F6BB49",
        "#DA3D53",
        "#379AB3",
        "#3068A0",
        "#1A4A6F",
        "#1A256F",
        "#070F41",
        "#000000"
    ];

    return (
        <>
        {category !== "design" || category !== "responsiveDesign" ? <section className="container mx-auto py-10 px-4 bg-white">
            <h2 className="text-2xl md:text-3xl font-bold text-black mb-4">{heading[category]}</h2>
            <div className="flex h-2 w-full max-w-lg mb-8">
                <div className="flex-1 bg-rose-500"></div>
                <div className="flex-1 bg-cyan-600"></div>
                <div className="flex-1 bg-blue-600"></div>
                <div className="flex-1 bg-sky-800"></div>
                <div className="flex-1 bg-indigo-900"></div>
            </div>
            <div className="w-full lg:ms-[20px]">
                <div className="flex md:justify-start justify-center flex-wrap 2xl:flex-nowrap w-full gap-y-2 w-100 capitalize">
                    {webProcess[category]?.title?.map((ele, ind) => {
                        return (
                            <div className="relative lg:ms-[-20px] lg:w-4/5  md:w-1/4 w-full lg:flex-1" key={ind}>
         
                                    <>
                                        {ind === 0 ? (
                                            <>
                                            <svg width="277" height="138" viewBox="0 0 277 138" fill="none" className="w-full h-auto flex-auto hidden md:block" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M246.667 0H0V19V69.5V119V138H246.667V119L276.667 69L246.667 19V0Z" fill={color[ind]} />
                                            </svg>
                                            <div className="w-full h-[80px] flex items-center justify-center md:hidden" style={{ backgroundColor: color[ind], borderRadius: 0 }}>
                                                <div className="text-center text-white font-semibold text-sm md:text-base px-2">{ele}</div>
                                            </div>
                                            </>
                                        ) : (
                                            ind === webProcess[category]?.title.length - 1 ? (
                                                <>
                                                <svg width="277" height="138" viewBox="0 0 277 138" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto hidden md:block">
                                                    <path d="M246.667 0H0V19L30 69L0 119V138H246.667V119V69V19V0Z" fill={color[ind]} />
                                                </svg>
                                                <div className="w-full h-[80px] flex items-center justify-center md:hidden" style={{ backgroundColor: color[ind], borderRadius: 0 }}>
                                                    <div className="text-center text-white font-semibold text-sm md:text-base px-2">{ele}</div>
                                                </div>
                                                </>
                                            ) : (
                                                <>
                                                <svg viewBox="0 0 277 138" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto hidden md:block">
                                                    <path d="M246.667 0H0V19L30 69L0 119V138H246.667V119L276.667 69L246.667 19V0Z" fill={color[ind]} />
                                                </svg>
                                                <div className="w-full h-[80px] flex items-center justify-center md:hidden" style={{ backgroundColor: color[ind], borderRadius: 0 }}>
                                                    <div className="text-center text-white font-semibold text-sm md:text-base px-2">{ele}</div>
                                                </div>
                                                </>
                                            )
                                        )}
                                        <div className="hidden md:block absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[90%] text-center text-white font-semibold text-sm xl:text-base px-3">{ele}</div>
                                    </>
                                
                            </div>
                        )
                    })}
                </div>
            </div>
            <div className="text-center bg-white py-10 px-4">
                <p className="text-purple-600 font-semibold text-base mb-2">{ctaData[category]?.subtitle}</p>
                <h2 className="text-2xl  sm:text-3xl 2xl:text-[40px] font-extrabold text-black mb-6">{ctaData[category]?.title}</h2>
                <Link to="/contact" className="inline-block bg-purple-500 hover:bg-purple-600 text-white text-sm font-semibold px-6 py-3 rounded-full transition">{ctaData[category]?.buttonText}</Link>
            </div>
        </section > : ""
        }
        </>
    )
}

export default KeyStepService;
